import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface DeleteUserInviteInput {
    inviteId: string;
}

export const useDeleteUserInvite = () => {
    const sessionContext = useContext(SessionContext);

    const deleteUserInvite = async (input: DeleteUserInviteInput) => {
        return axios.delete(`${API_URL}/settings/user/invite`, {
            headers: {
                Authorization: sessionContext?.sessionId ?? ''
            },
            data: input
        });
    };

    return useMutation({
        mutationFn: deleteUserInvite,
    });
};
